import React from 'react'
import styled, {css} from 'styled-components'

import rem from '../../utils/rem'
import { navbarHeight } from '../../utils/sizes'
import NavSeparator from './NavSeparator'
import Link from '../Link'
import * as colors from '../../utils/colors'

const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  float: right;
`

const NavLink = styled(Link).attrs({
  unstyled: true
})`
  flex: 0 0 auto;
  display: inline-block;
  line-height: ${rem(navbarHeight)};
  transition: opacity 0.2s, transform 0.2s;
  cursor: pointer;
  text-decoration: none;

  letter-spacing: ${rem(0.4)};
  color: currentColor;

  &:hover,
  &:focus {
    opacity: 0.9;
  }

  &:active  {
    transform: scale(1.02);
    opacity: 0.7;
  }
`

const rounded = css`
  border-radius: 2px;
`

const NavActionButton = styled(NavLink)`
  ${rounded};
  background: ${colors.primaryHighlight};
  color: ${colors.primaryHighlightContrast};
  padding: 0 16px;
  line-height: ${rem(navbarHeight) - 1};

  &:hover{
  background: ${colors.primaryLowlight} ;
  }
`

const NavActio2nButton = styled.button`
    color: white;
    cursor: pointer;
    background-color: #e50914;
    line-height: normal;
    margin: 18px 3% 0 0;
    padding: 7px 17px;
    font-weight: 100;
    border: transparent;
    border-radius: 3px;
    font-size: 16px;
    text-decoration: none;

    ${props => props.right && css`
        float: right;
    `}
    &:hover {
        background-color: #E53935;
    }
`;

const ccc = styled.button`
    color: white;
    cursor: pointer;
    background-color: #e50914;
    line-height: normal;
    margin: 18px 3% 0 0;
    padding: 7px 17px;
    font-weight: 100;
    border: transparent;
    border-radius: 3px;
    font-size: 16px;
    text-decoration: none;

    ${props => props.right && css`
        float: right;
    `}
    &:hover {
        background-color: #E53935;
    }
`;

const NavLinks = () =>
  <Wrapper>
      {/*<NavLink href="/philosophy">Philosophy</NavLink>*/}
    {/*<NavSeparator />*/}
      {/*<NavLink href="/work">Work</NavLink>*/}
    {/*<NavSeparator />*/}
    {/*<NavLink href="/about">About</NavLink>*/}
      {/*<NavSeparator />*/}
      {/*<NavActionButton href="/contact">Get in touch!</NavActionButton>*/}
  </Wrapper>

export default NavLinks



// WEBPACK FOOTER //
// ./src/components/Nav/NavLinks.js